import api from '@pray/shared/utils/api';

export type InstanceGroup = {
  name: string;
  displayName: string;
  versions: number[];
  latestVersion: number;
  totalExperiments: number;
  activeExperiments: number;
  hasEntityDefinition: boolean;
  platform?: 'ios' | 'android' | 'web' | 'all';
};

export type InstanceGroupsStats = {
  totalInstanceGroups: number;
  totalExperiments: number;
  activeExperiments: number;
};

export type GetInstanceGroupsResponse = {
  data: {
    instanceGroups: InstanceGroup[];
    stats: InstanceGroupsStats;
  };
};

export type GetInstanceGroupsParams = {
  includeArchived?: boolean;
};

/**
 * Returns all experiment instance groups with version counts and experiment stats
 * @param includeArchived - Whether to include archived experiments in the counts
 */
export async function getInstanceGroups({ includeArchived = false }: GetInstanceGroupsParams = {}) {
  const params: Record<string, string | boolean> = {};

  if (includeArchived) params.include_archived = true;

  const url = '/web/studio/experiments/instance-groups';

  const response = await api.executeGetRequest<GetInstanceGroupsResponse>(url, params);

  return response.data;
}
